import { db } from "../../services/firebase";
import {
  doc,
  getDoc,
  collection,
  query,
  where,
  getDocs
} from "firebase/firestore";

export async function getServiceAnalyticsClient({ serviceId }) {
  const serviceRef = doc(db, 'services', serviceId);
  const serviceSnap = await getDoc(serviceRef);
  
  if (!serviceSnap.exists()) {
    throw new Error('Service not found');
  }
  
  const serviceDetails = serviceSnap.data();
  
  // Get click data
  const clicksRef = collection(db, 'service_clicks');
  const q = query(clicksRef, where('serviceId', '==', serviceId));
  const querySnapshot = await getDocs(q);
  const clickData = querySnapshot.docs.map((doc) => doc.data());
  
  return {
    serviceDetails,
    clickData
  };
}